import React from 'react';
import './why-choose-us.css'; 
import { FaLayerGroup, FaGlobe, FaShieldAlt, FaChartLine } from 'react-icons/fa';

const WhyChooseUs = () => {
const tiers = [
  { 
    id: 1,
    icon: <FaLayerGroup />, 
    title: "Expert Leadership", 
    description: "Our leadership draws on years of experience across multiple fintech ventures, ensuring every decision is guided by proven frameworks and deep industry insight."
  },
  { 
    id: 2,
    icon: <FaGlobe />, 
    title: "Wide Market Reach", 
    description: "With an expansive operational network and strategic partnerships, we are able to serve clients seamlessly across regions while optimizing processes and efficiency."
  },
  { 
    id: 3,
    icon: <FaShieldAlt />, 
    title: "Financial Reliability", 
    description: "Backed by strong capital reserves and robust governance policies, we deliver consistent stability, build trust with partners, and provide secure lending operations."
  },
  { 
    id: 4,
    icon: <FaChartLine />, 
    title: "Continuous Innovation", 
    description: "Our dedicated R&D initiatives continuously drive technological evolution, enabling scalable, future-ready solutions that keep our fintech ecosystem at the forefront of the industry."
  },
];

  return (
    <section id="why-choose-us" className="why-choose-us-section wireframe-bg">
      <div className="container py-4 py-md-5">
        
        {/* Section Heading */}
        <header className="text-center mb-4 mb-md-5">
          <h2 className="display-3 choose-title mb-3">
            Why We Stand Out
          </h2>
          <p className="lead text-dark-secondary mx-auto" style={{ maxWidth: '800px' }}>
            Strengths that define our fintech ecosystem: expertise, reliability, innovation, and wide-reaching impact.
          </p>
        </header>

        {/* Tier Cards */}
        <div className="wireframe-grid-container">
          {tiers.map((tier, index) => (
            <div 
              key={tier.id} 
              className="wireframe-item"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="wireframe-content">
                <div className="item-icon-box">
                  {tier.icon}
                </div>
                <div className="item-text">
                  <h3 className="item-title fw-bold">{tier.title}</h3>
                  <p className="item-description mb-0">{tier.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
      </div>
    </section>
  );
};

export default WhyChooseUs;
